<template>
  <div>
    <Map @detail="getDetail" :enterpriseListShow="enterpriseListShow"></Map>
    <map-guide-page @alwaysClose="doAlwaysClose" v-model="guidePageShow" @onStep="doGuideStep"></map-guide-page>
    <div v-if="location.site" class="drawer-show drawer-show-0" @click.stop="doDrawerShow"><i class="el-icon-arrow-left"></i></div>
    <el-drawer append-to-body class="drawer-no-header" :visible.sync="enterpriseListShow" :with-header="false" size="1036">
      <drawer-enterprise-list ref="drawerList" :location="location" v-if="enterpriseListCreateShow">
        <div class="drawer-show-1" @click="doClose"><i class="el-icon-arrow-right"></i></div>
      </drawer-enterprise-list>
    </el-drawer>
    <right-float ref="rightFloat" :globalRfType="true"></right-float>
  </div>
</template>

<script>
import Map from "@/components/qq-map/map.vue"
import mapGuidePage from '@/views/commercialMap/components/mapGuidePage'
import drawerEnterpriseList from '@/views/parkCustomer/components/drawerEnterpriseList'
import RightFloat from '@/components/rightFloatBtn'
const guideShowKey = 'park-customer-guide-page'
const mapGuiPageShow = () => !localStorage.getItem(guideShowKey)
const circleOptions = { strokeWeight: 1, strokeColor: '#b8ceed', fillColor: '#b6c9eb', fillOpacity: 0.3, strokeOpacity: 1 }
const getArr = (str, func) => {
  if (!str) return []
  if (!func) return []
  return func(str)
}
let [map, drawingManager] = [null, null]

export default {
  name: 'parkCustomer',
  components: { Map, mapGuidePage, drawerEnterpriseList, RightFloat },
  data() {
    return {
      input: '',
      enterpriseListCreateShow: false,
      enterpriseListShow: false,
      location: {
        site: null,
        latitude: null,
        longtitude: null,
        distance: 0
      },
      oldPoint: null,
      oldX: 0,
      oldY: 0,
      guidePageShow: mapGuiPageShow(),
      hide: false
    }
  },
  watch: {
    enterpriseListShow: {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        if (val && this.oldPoint) {
          const width = Math.max(document.body.clientWidth - 1036 - 224, 0)
          const height = Math.max(document.body.clientHeight - 120, 0)
          const { x, y } = map.pointToPixel(this.oldPoint)
          this.oldX = width / 2 - x
          this.oldY = height / 2 - y
          map.panBy(this.oldX, this.oldY)
        } else if (!val && this.oldPoint) {
          map.panBy(-this.oldX, -this.oldY)
        }
      }
    },
    'location.site': {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        if (val) {
          this.$nextTick(this.resizeDrawerShow0)
        }
      }
    }
  },
  mounted() {
    if (this.$route.query.hide) this.hide = true
    window.onresize = this.resizeDrawerShow0
    window.addEventListener('click', this.clickOutSelectCity)
    const vertical = document.querySelector('.content-scrollbar .is-vertical')
    vertical && (vertical.style.display = 'none')
    // this.mapInit()
  },
  created: function () {
    document.onkeydown = function (e) {
      var evt = window.event || event
      if (evt.keyCode === 13) {
        if (evt.preventDefault) {
          evt.preventDefault()
        } else {
          evt.returnValue = false
        }
      }
    }
  },
  methods: {
    async getDetail(data) {
      this.location = data;
      this.enterpriseListCreateShow = true;
      await this.$nextTick()
      this.$refs.drawerList?.initData?.()
      if (data.isEmit) {
        this.enterpriseListShow = true;
      }
    },
    G(id) {
      return document.getElementById(id)
    },
    resizeDrawerShow0() {
      const drawerShow0 = document.querySelector('.drawer-show-0')
      if (!drawerShow0) return
      const app = document.querySelector('#app')
      const offsetWidth = app.offsetWidth
      const scrollWidth = app.scrollWidth
      const dx = 10 - (scrollWidth - offsetWidth)
      const right = Math.max(0, dx)
      drawerShow0.style.right = `${right}px`
    },
    doGuideStep(step) {
      if (step == 1 && drawingManager) {
        drawingManager.setDrawingMode(BMAP_DRAWING_CIRCLE)
        drawingManager.open()
      }
    },
    doClose() {
      this.enterpriseListShow = false
    },
    doAlwaysClose() {
      localStorage.setItem(guideShowKey, 1)
    },
    doDrawerShow() {
      this.enterpriseListShow = true
    },
    mapInit() {
      const vm = this
      map = new BMap.Map('map-wrapper', { enableMapClick: false })
      const point = new BMap.Point(121.480193, 31.236333) // 创建点坐标
      map.addControl(new BMap.ScaleControl({ anchor: BMAP_ANCHOR_BOTTOM_LEFT }))
      const options = { renderOptions: { map: map }, onSearchComplete: (results) => { } }
      map.centerAndZoom(point, 12)

      // 地理位置
      const geolocation = new BMap.Geolocation()
      geolocation.getCurrentPosition(function (r) { // 获取不到位置信息的时候报错
        if (this.getStatus() !== BMAP_STATUS_SUCCESS) {
          const message = vm.Global.getBaiDuApiErrorMsg(this.getStatus())
          if (message) {
            alert(message)
            return
          }
        }
        map.panTo(r.point)
      })

      // 城市  切换城市之后事件onChangeAfter() { },  onChangeBefore() { },  onChangeSuccess() { }
      map.addControl(new BMap.CityListControl({ anchor: BMAP_ANCHOR_TOP_LEFT, offset: new BMap.Size(160, 10) }))
      // 增加放大缩小的控件
      map.addControl(new BMap.NavigationControl({ anchor: BMAP_ANCHOR_BOTTOM_LEFT, type: BMAP_NAVIGATION_CONTROL_ZOOM }))
      // map.centerAndZoom(point, 12) // 初始化地图，设置中心点坐标和地图级别
      map.enableScrollWheelZoom()


      // // 将地图显示在指定区域，地图被拖出该区域后弹回
      // var b = new BMap.Bounds(new BMap.Point(116.027143, 39.772348),new BMap.Point(116.832025, 40.126349));
      // try{
      //     BMapLib.AreaRestriction.setBounds(map, b)
      // }catch(e){
      //     // alert(e)
      // }

      drawingManager = new BMapLib.DrawingManager(map, {
        isOpen: true, // 是否开启绘制模式
        enableDrawingTool: true, // 是否显示工具栏
        drawingToolOptions: {
          anchor: BMAP_ANCHOR_TOP_LEFT, // 位置
          offset: new BMap.Size(20, 10), // 偏离值
          drawingModes: [BMAP_DRAWING_CIRCLE]
        },
        circleOptions
      })

      const localSearch = new BMap.LocalSearch(map, options)
      const geoc = new BMap.Geocoder()
      drawingManager.addEventListener('circlecomplete', function (e, overlay) {

        const radius = parseInt(e.getRadius())
        if (!radius) {
          // vm.$message.warning('范围选择太小')
          // vm.$message.error('选择范围太小')
          vm.$message({
            message: '选择范围太小',
            type: 'error',
            customClass: 'customTop'
          })
          return
        }
        vm.enterpriseListCreateShow = false
        map.clearOverlays()
        map.addOverlay(overlay)
        const center = e.getCenter()
        const { lng: longtitude, lat: latitude } = center
        geoc.getLocation(center, function (res) {
          const { province = '', city = '', district = '', street = '', streetNumber = '' } = res.addressComponents
          const site = province + city + district + street + streetNumber
          vm.location = { ...vm.location, site, distance: radius, latitude, longtitude }
          vm.enterpriseListCreateShow = true
          // const { x, y } = map.pointToPixel(center);
          vm.oldPoint = center
          vm.enterpriseListShow = true
          vm.$nextTick(() => vm.$refs.drawerList.initData())
        })

        localSearch.searchNearby('积水点', center, radius, { customData: { geotableId: 91687 } })
        drawingManager.close()
        vm.triggerClick()
      })
      // 搜索框
      var ac = new BMap.Autocomplete( // 建立一个自动完成的对象
        {
          input: 'suggestId',
          location: map.getCenter()
        })
      ac.addEventListener('onhighlight', function (e) { // 鼠标放在下拉列表上的事件
        var str = ''
        var _value = e.fromitem.value
        var value = ''
        if (e.fromitem.index > -1) {
          // _value.province + _value.city + _value.district +_value.street +
          value = _value.business
        }
        str = 'FromItem<br />index = ' + e.fromitem.index + '<br />value = ' + value

        value = ''
        if (e.toitem.index > -1) {
          _value = e.toitem.value
          value = _value.business
        }
        str += '<br />ToItem<br />index = ' + e.toitem.index + '<br />value = ' + value
        vm.G('searchResultPanel').innerHTML = str
      })
      var myValue
      ac.addEventListener('onconfirm', function (e) { // 鼠标点击下拉列表后的事件
        var _value = e.item.value
        myValue = _value.business
        // vm.input = myValue
        vm.G('searchResultPanel').innerHTML = 'onconfirm<br />index = ' + e.item.index + '<br />myValue = ' + myValue
        map.clearOverlays() // 清除地图上所有覆盖物
        function myFun() {
          var pp = local.getResults().getPoi(0).point // 获取第一个智能搜索的结果
          map.centerAndZoom(pp, 12)
          map.addOverlay(new BMap.Marker(pp)) // 添加标注
          var circle = new BMap.Circle(pp, 5000, circleOptions) // 画圈
          map.addOverlay(circle) // 添加范围圈
          // 打开侧边栏
          const { lng: longtitude, lat: latitude } = pp
          const site = _value.business // 地址
          vm.location = { ...vm.location, site, distance: 5000, latitude, longtitude }
          vm.enterpriseListCreateShow = true
          vm.oldPoint = pp
          vm.enterpriseListShow = true
          vm.$nextTick(() => vm.$refs.drawerList.initData())
          vm.$nextTick(() => vm.$refs.drawerList.dragRefresh())
        }
        var local = new BMap.LocalSearch(map, { // 智能搜索
          onSearchComplete: myFun
        })

        local.search(myValue)
        document.querySelector('#suggestId').value = myValue
        document.querySelector('#suggestId').blur()
        setTimeout(() => {
          document.querySelector('#tangram-suggestion--TANGRAM__1q-main').style.display = 'none'
        }, 1000)
      })
      drawingManager.close()
    },
    remove() { },
    close() { },

    clickOutSelectCity(e) {
      const outSelectCity = !this.hasParents(e.target, '.BMap_CityListCtrl') // 点击城市选择器以外的区域
      const citylist_popup_main = document.querySelector('.citylist_popup_main')
      const selectCityIsOpen = citylist_popup_main && citylist_popup_main.style.display === 'block' ? !0 : !1 // 城市选择器是否展开
      if (outSelectCity && selectCityIsOpen) {
        this.triggerClick()
      }
    },

    hasParents(elClass, parentSelectorClass) {
      if (!elClass || !parentSelectorClass) {
        return false
      }
      let [el, parentsSelectors] = [elClass, parentSelectorClass]
      if (typeof elClass === 'string') {
        el = document.querySelector(elClass)
        if (!el) {
          return false
        }
      }
      if (typeof parentsSelectors === 'string') {
        parentsSelectors = document.querySelectorAll(parentsSelectors)
      } else {
        parentsSelectors = [...parentsSelectors]
      }
      let hasParents = false
      for (let i = 0; i < parentsSelectors.length; i++) {
        let p = el.parentNode
        while (p !== parentsSelectors[i]) {
          if (!p || p === document) {
            break
          }
          p = p.parentNode
        }
        if (p === parentsSelectors[i]) {
          hasParents = true
        }
      }
      return hasParents
    },

    triggerClick() { // 自动触发城市列表控件的关闭按钮
      const closeBtn = document.getElementById('popup_close')
      if (document.all) {
        closeBtn && closeBtn.click()
      } else {
        const e = document.createEvent('MouseEvents')
        e.initEvent('click', true, true)
        closeBtn && closeBtn.dispatchEvent(e)
      }
    }
  },
  destroyed() {
    window.removeEventListener('click', this.clickOutSelectCity)
    const vertical = document.querySelector('.content-scrollbar .is-vertical')
    vertical && (vertical.style.display = null)
  }
}
</script>

<style lang="scss" scoped>
.style2 {
  right: 0;
}
.search-box {
  position: absolute;
  z-index: 23;
  background: #fff;
  width: 910px;
  right: -910px;
  height: 100%;
  transition: right 0.8s ease-in-out;
  &.active {
    right: 0px;
    overflow: auto;
  }
  &.active1 {
    right: 0px;
  }
  &.default {
    right: -960px;
  }
  .close {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: -42px;
    background: #ffffff;
    width: 40px;
    height: 90px;
    text-align: center;
    z-index: 3;
    i {
      line-height: 90px;
      font-size: 30px;
    }
  }
}
.drawer-show-1 {
  position: absolute;
  top: 50%;
  transform: translate(-100%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  left: 0;
  cursor: pointer;
  width: 24px;
  height: 40px;
  background: #4286f5;
  border-radius: 4px 0px 0px 4px;
  i {
    transform: translateX(1px);
    animation: my-move 2s infinite;
    animation-direction: alternate; /*轮流反向播放动画。*/
    animation-timing-function: linear; /*动画的速度曲线*/
    // font-size: 20px;
    font-size: 12px;
  }
}

@keyframes my-move {
  0% {
    transform: translateX(1px); /*开始为原始大小*/
  }
  25% {
    transform: translateX(-2px); /*放大1.1倍*/
  }
  50% {
    transform: translateX(1px);
  }
  75% {
    transform: translateX(-2px);
  }
}

.drawer-show {
  z-index: 1;
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  color: #2279b5;
  // width: 24px;
  // height: 80px;
  right: 10px;
  // border-radius: 5px 0 0 5px;
  // box-shadow: -3px 1px 3px #0000004c;
  cursor: pointer;
  // background: #fff;

  width: 24px;
  height: 40px;
  background: #4286f5;
  color: #ffffff;
  border-radius: 4px 0px 0px 4px;
  i {
    transform: translateX(1px);
    animation: my-move 2s infinite;
    animation-direction: alternate; /*轮流反向播放动画。*/
    animation-timing-function: linear; /*动画的速度曲线*/
    // font-size: 20px;
    font-size: 12px;
  }
}
::v-deep {
  .el-drawer__body {
    padding: 0;
  }
}
</style>

<style lang="scss">
.tel-dialog {
  .el-dialog__header,
  .el-dialog__footer {
    border: 0 !important;
  }
  .el-dialog__title {
    font-size: 16px;
  }
  .el-dialog__body {
    padding: 10px 50px;
  }
}

.drawer-no-header {
  overflow: hidden;
  .el-drawer {
    overflow: visible;
  }
}
.drawer-no-header .el-drawer__header {
  display: none;
}
</style>
